import { HostType } from '@/types/enums';

function getHostType(hostType: HostType | string): string {
  if (hostType === HostType.Standard) return '标准版';
  if (hostType === HostType.Professional) return '专业版';
  return '入门版';
}

export default getHostType;
